import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DropdownButton, NavItem } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import Select from "react-select";

import * as callActions from "../../actions/callActions";
import * as contractActions from "../../actions/contractActions";
import * as contactActions from "../../actions/contactActions";
import * as userActions from "../../actions/userActions";
import * as projectActions from "../../actions/projectActions";
import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as serviceActions from "../../actions/serviceActions";
import * as modalActions from "../../actions/modalActions";
import * as supportTicketActions from "../../actions/supportTicketActions";

import { formatDate } from "../../helpers/date";

import SupportTicketForm from "./SupportTicketForm";
import HeaderWrapper from "../common/HeaderWrapper";
import SupportTicketDisplay from "./SupportTicketDisplay";
import CallList from "../call/CallList";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";
import Badge from "../common/Badge";
import AuditLogList from "./AuditLogList";
import { customToast as toast } from "../../utils";
import Checkbox from "../common/Checkbox";
import Loading from "../common/Loading";

class ViewSupportTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      calls: [],
      supportTicket: {},
      deleteRecurring: false,
      selectedPriority: "",
      actionRequiredBy: "",
      fetchedProjects: false,
      sendCustomerEmail: true
    };
  }

  componentDidMount = async () => {
    const { customers, contracts, users, codes, projects, match, actions } =
      this.props;
    actions.getSupportTicket(match.params.id);

    const { calls } = await actions.loadCalls({
      isPopulated: true,
      filtered: { support_ticket_id: [match.params.id] }
    });
    if (isEmpty(customers)) {
      actions.loadCustomers();
    }
    if (isEmpty(contracts)) {
      actions.loadContracts();
    }
    if (isEmpty(users)) {
      actions.loadUsers();
    }
    if (isEmpty(codes)) {
      actions.loadCodes();
    }
    if (isEmpty(projects)) {
      actions.loadProjects();
    }
    this.setState({ calls });
  };

  onChangePriorityClick = (priority) => {
    if (this.props.supportTicket.request_priority !== priority) {
      this.setState({ selectedPriority: priority });
      this.props.actions.showModalSuccess("priorityModal");
    }
  };

  onClickAssign = () => {
    this.props.actions.showModalSuccess("supportTicketModal");
  };

  onClickAdd = () => {
    this.props.actions.showModalSuccess("supportTicketModalAddCall");
  };

  onClickHold = () => {
    this.props.actions.showModalSuccess("holdTicketModal");
  };

  onClickResolve = () => {
    let close = true;
    this.state.calls.forEach((call) => {
      if (call.stage.order < 4) {
        close = false;
      }
    });
    if (close) {
      this.props.actions.showModalSuccess("resolveTicketModal");
    } else {
      alert(
        "There are still open calls associated with this ticket. Please review any open calls before continuing."
      );
    }
  };

  onSaveTicket = async (call) => {
    this.setState({ loading: true });
    const { supportTicket, auth, codes, contracts } = this.props;

    const contract = contracts?.find((item) => item._id === call.contract);

    const request_status = find(codes, {
      entity: "Support Ticket",
      value: "IP"
    });

    const updatedSupportTicket = {
      ...supportTicket,
      assigned_to: call.assigned_to,
      is_assigned: true,
      customer: call.customer,
      assigned_by: auth.user._id,
      entered_on: formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      request_status: request_status._id,
      modified_by_user_id: auth.user._id,
      project: call.project,
      tier: contract?.tier,
      internal_note: call.internal_note || ""
    };
    if (call.internal_cc) {
      updatedSupportTicket.internal_cc = call.internal_cc;
    }

    const updatedTicket = await this.props.actions.updateSupportTicket(
      updatedSupportTicket,
      false,
      "supportTicketModal"
    );

    if (updatedTicket) {
      const createdCall = await this.props.actions.createCall(call);
      if (updatedTicket.showPrompt) {
        const customer = this.props.customers.find(
          (c) => c._id === call.customer
        );
        this.setState({
          callToRedirect: {
            _id: createdCall._id,
            customer
          },
          requestor_company_name: supportTicket.requestor_company_name
        });
        this.props.actions.showModalSuccess("addAltNameModal");
      } else {
        if (updatedTicket.altNameInUse) {
          toast.warning(
            `${updatedTicket.altNameInUse.requestor_company_name} is an alternative name for ${updatedTicket.altNameInUse.customer}. See Alternative Names page.`,
            8000
          );
        }
        if (updatedTicket.showProjectPrompt && auth.maxRole >= 4000) {
          const project = this.props.projects.find(
            (p) => p._id === call.project
          );
          this.setState({
            callToRedirect: {
              _id: createdCall._id,
              customer: call.customer,
              project
            }
          });
          this.props.actions.showModalSuccess("projectKeywordsModal");
        } else {
          this.props.history.push(`/app/calls/${createdCall._id}`);
        }
      }
    }
  };

  handleAddAlternativeNameConfirm = async () => {
    this.props.actions.hideModal("addAltNameModal");
    await this.props.actions.updateCustomer({
      id: this.state.callToRedirect.customer._id,
      alternative_names: this.state.callToRedirect.customer.alternative_names
        ? [
            ...this.state.callToRedirect.customer.alternative_names,
            this.state.requestor_company_name
          ]
        : [this.state.requestor_company_name]
    });
    this.props.history.push(`/app/calls/${this.state.callToRedirect._id}`);
  };

  handleAddAlternativeNameCancel = async () => {
    this.props.actions.hideModal("addAltNameModal");
    this.props.history.push(`/app/calls/${this.state.callToRedirect._id}`);
  };

  handleAddProjectKeywordsConfirm = async () => {
    this.props.actions.hideModal("projectKeywordsModal");
    this.props.history.push(
      `/app/project-keywords?customer=${this.state.callToRedirect.customer}`
    );
  };

  handleAddProjectKeywordsCancel = async () => {
    this.props.actions.hideModal("projectKeywordsModal");
    this.props.history.push(`/app/calls/${this.state.callToRedirect._id}`);
  };

  onSaveNewCall = async (call) => {
    const createdCall = await this.props.actions.createCall(call);

    this.props.history.push(`/app/calls/${createdCall._id}`);
  };

  onCancel = () => {
    const {
      supportTicket: { is_assigned }
    } = this.props;

    return is_assigned
      ? this.props.actions.hideModal()
      : this.props.history.goBack();
  };

  onClickDelete = (id, deleteRecurring) => {
    this.props.actions.requestCallId(id);
    this.setState({ deleteRecurring });
  };

  onClickAddLog = () => {
    this.props.actions.showModalSuccess("auditLogModal");
  };

  onCloseModal = () => {
    this.props.actions.hideModal();
    this.setState({ note: "" });
  };

  getButtons = () => {
    const {
      supportTicket: { request_status, is_assigned }
    } = this.props;

    const buttons = [];
    if (request_status?.order < 2 && is_assigned) {
      buttons.unshift(
        {
          action: this.onClickResolve,
          text: "Resolve",
          className: "btn-purple"
        },
        {
          action: this.onClickAssign,
          text: "Reassign",
          className: "btn-warning"
        },
        {
          action: this.onClickHold,
          text: "Hold",
          className: "btn-success"
        }
      );
    }
    if (request_status?.order === 2) {
      buttons.unshift({
        action: this.handleReopen,
        text: "Reopen",
        className: "btn-warning"
      });
    }
    if (request_status?.order === 3) {
      buttons.unshift(
        {
          action: this.handleReopen,
          text: "Reopen",
          className: "btn-warning"
        },
        {
          action: this.onClickResolve,
          text: "Resolve",
          className: "btn-purple"
        },
        {
          action: this.onClickAssign,
          text: "Reassign",
          className: "btn-warning"
        }
      );
    }

    return buttons;
  };

  fetchCalls = async () => {
    const { actions, match } = this.props;
    try {
      const { calls } = await actions.loadCalls({
        isPopulated: true,
        filtered: { support_ticket_id: [match.params.id] }
      });
      this.setState({ calls });
    } catch (err) {
      toast.error(err.message);
    }
  };

  confirmDelSingle = async () => {
    await this.props.actions.deleteCall(this.props.callToDelete);
    await this.props.actions.hideModal();
    await this.reload();
  };

  confirmDelSeries = async () => {
    const callToDelete = find(this.state.calls, {
      _id: this.props.callToDelete
    });
    await this.props.actions.deleteRecurringCalls(callToDelete.recurring_id);
    await this.props.actions.hideModal();
    await this.reload();
    await this.setState({ deleteRecurring: false });
  };

  handleResolve = async () => {
    const { supportTicket, codes, auth } = this.props;
    const request_status = find(codes, {
      entity: "Support Ticket",
      field: "status",
      value: "R"
    });

    const resolution = {
      resolved_by: auth.user._id,
      closing_note: this.state.note,
      resolved_on: new Date()
    };

    const data = {
      ...supportTicket,
      request_status: request_status._id,
      resolution,
      modified_by_user_id: auth.user._id,
      additional_note: this.state.note,
      send_customer_email: this.state.sendCustomerEmail
    };
    await this.props.actions.updateSupportTicket(data);
    this.props.actions.getSupportTicket(this.props.match.params.id);
  };

  handleHold = async () => {
    const { supportTicket, codes, auth } = this.props;
    const request_status = find(codes, {
      entity: "Support Ticket",
      field: "status",
      value: "H"
    });

    const data = {
      ...supportTicket,
      request_status: request_status._id,
      modified_by_user_id: auth.user._id,
      additional_note: this.state.note,
      actionRequiredBy: this.state.actionRequiredBy?.value
    };
    await this.props.actions.updateSupportTicket(data);
    this.props.actions.getSupportTicket(this.props.match.params.id);
  };

  handleReopen = async () => {
    const { supportTicket, codes, auth, match } = this.props;
    const inProcessStatus = codes.find(
      (c) => c.label === "In Process" && c.entity === "Support Ticket"
    );
    const reOpenedStatus = codes.find(
      (c) => c.label === "ReOpened" && c.entity === "Support Ticket"
    );
    const data = {
      ...supportTicket,
      request_status: inProcessStatus._id,
      modified_by_user_id: auth.user._id
    };
    const newAuditLog = {
      note: "Ticket reopened",
      action: reOpenedStatus._id,
      user: auth.user._id
    };
    await this.props.actions.addAuditLog(match.params.id, newAuditLog);
    await this.props.actions.updateSupportTicket(data);
    this.props.actions.getSupportTicket(this.props.match.params.id);
  };

  handleInput = (e) => {
    const { value } = e.target;
    this.setState({ note: value });
  };

  handleCheckbox = (e) => {
    this.setState({ sendCustomerEmail: e?.target?.checked });
  };

  handleDelete = async () => {
    await this.props.actions.deleteCall(this.props.callToDelete);
    // await this.reload();
    await this.fetchCalls();
  };

  handleAddAuditLog = async () => {
    const { match, auth } = this.props;
    const newAuditLog = {
      note: this.state.note,
      user: auth.user._id
    };
    await this.props.actions.addAuditLog(match.params.id, newAuditLog);
    await this.props.actions.getSupportTicket(match.params.id);
  };

  handleChangePriority = async () => {
    const { supportTicket, auth, match, codes } = this.props;
    const data = {
      ...supportTicket,
      request_priority: this.state.selectedPriority,
      request_status: supportTicket.request_status._id
    };
    await this.props.actions.updateSupportTicket(data);

    const up_code = find(codes, {
      entity: "Support Ticket",
      value: "UP"
    });

    const auditLogData = {
      user: auth.user._id,
      action: up_code?._id,
      note: `${auth.user.full_name} updated the request priority from ${supportTicket.request_priority} to ${this.state.selectedPriority}. ${this.state.note}`
    };

    await this.props.actions.addAuditLog(match.params.id, auditLogData);
    this.props.actions.getSupportTicket(this.props.match.params.id);
  };

  componentWillUnmount = () => {
    this.props.actions.clearSupportTicket();
  };

  render() {
    const {
      auth,
      customers,
      contracts,
      projects,
      users,
      codes,
      isMobile,
      supportTicket
    } = this.props;

    const { calls, deleteRecurring } = this.state;

    const isExistingTicket = !isEmpty(calls) || supportTicket?.assigned_to;
    const lastCall = calls[calls.length - 1];

    const assignForm = (
      <SupportTicketForm
        supportTicket={supportTicket}
        customers={customers}
        contracts={contracts}
        projects={projects}
        call={lastCall}
        users={users}
        auth={auth}
        codes={codes}
        saving={this.state.loading}
        onSave={this.onSaveTicket}
        onCancel={this.onCancel}
        onAddContact={this.handleAddContact}
        editing
        adding
        callDefaultAssignedTo
        callDefaultCustomer
        callDefaultProject
      />
    );

    const addCallForm = (
      <SupportTicketForm
        supportTicket={supportTicket}
        customers={customers}
        contracts={contracts}
        projects={projects}
        call={lastCall}
        users={users}
        auth={auth}
        codes={codes}
        saving={this.props.savingCall}
        onSave={this.onSaveNewCall}
        onCancel={this.onCancel}
        onAddContact={this.handleAddContact}
        editing
        adding
      />
    );

    const confirmClose = (
      <div>
        <p>Are you sure you want to resolve this ticket?</p>
        <textarea
          maxLength="250"
          className="form-control"
          onChange={this.handleInput}
          placeholder="Note"
        />
        <small
          style={{
            float: "right",
            color: this.state.note && this.state.note.length >= 250 ? "red" : ""
          }}
        >
          {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
          Limit
        </small>
        <div
          style={{ display: "flex", alignItems: "center", marginTop: "2rem" }}
        >
          <Checkbox
            name="sendCustomerEmail"
            checked={this?.state?.sendCustomerEmail}
            onClickCheck={this.handleCheckbox}
          />
          <div style={{ marginLeft: "1rem" }}>
            Send Customer Email
            <small style={{ marginLeft: "1rem" }}>
              *This includes the resolution note above.
            </small>
          </div>
        </div>
      </div>
    );

    const holdModalForm = (
      <div style={{ minHeight: "25rem" }}>
        <p>
          Enter a reason for placing ticket on Hold. This note will be sent to
          the customer.
        </p>
        <div className="hold-modal-wrapper">
          <textarea
            maxLength="250"
            className={
              auth.isNightMode ? "form-control-dark" : "form-control-light"
            }
            onChange={this.handleInput}
            placeholder="Note"
          />
          <small
            style={{
              float: "right",
              color:
                this.state.note && this.state.note.length >= 250 ? "red" : ""
            }}
          >
            {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
            Limit
          </small>
        </div>
        <Select
          fullwidth
          className="react-select-container"
          classNamePrefix="react-select-container"
          placeholder="Action Required By"
          value={this.state.actionRequiredBy}
          options={[
            { label: "Gravoc", value: "Gravoc" },
            { label: "Customer", value: "Customer" }
          ]}
          onChange={(e) => {
            this.setState({ actionRequiredBy: e });
          }}
        />
      </div>
    );

    const ticketModalForm = (
      <div>
        <p>Add some description</p>
        <textarea
          maxLength="250"
          className="form-control"
          onChange={this.handleInput}
          placeholder="Note"
        />
        <small
          style={{
            float: "right",
            color: this.state.note && this.state.note.length >= 250 ? "red" : ""
          }}
        >
          {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
          Limit
        </small>
      </div>
    );

    const changePriorityForm = (
      <div>
        <p>
          Would you like to update this ticket to priority{" "}
          {this.state.selectedPriority}?
        </p>
        <textarea
          maxLength="250"
          className="form-control"
          onChange={this.handleInput}
          placeholder="Note"
        />
        <small
          style={{
            float: "right",
            color: this.state.note && this.state.note.length >= 250 ? "red" : ""
          }}
        >
          {this.state.note ? `${this.state.note.length} / ` : ""}250 Character
          Limit
        </small>
      </div>
    );

    const getClassName = (request_priority) => {
      if (request_priority === "Normal") {
        return "warning";
      }
      if (request_priority === "High") {
        return "danger";
      }
      return "success";
    };

    const className = getClassName(supportTicket?.request_priority);

    const actions = (
      <span>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSingle}
        >
          Delete Single
        </button>
        <button
          className="btn btn-success"
          type="button"
          onClick={this.confirmDelSeries}
        >
          Delete Series
        </button>
      </span>
    );

    if (isEmpty(supportTicket)) {
      return (
        <div
          style={{
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Loading />
        </div>
      );
    }

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[
            {
              label: `Support Ticket #${
                supportTicket?.support_ticket_number || ""
              }`
            }
          ]}
          onClickEdit={this.handleEdit}
          onClickAction={this.getButtons()}
          isMobile={isMobile}
          icon={
            <React.Fragment>
              {supportTicket.request_priority && (
                <div
                  className="dropdown-on-header"
                  style={{ display: "inline-block" }}
                >
                  <DropdownButton
                    id="priorities-dropdown"
                    className={`no-default btn-${className}`}
                    style={{ marginTop: 3 }}
                    title={supportTicket.request_priority}
                  >
                    <NavItem
                      active={supportTicket.request_priority === "Low"}
                      onClick={() => this.onChangePriorityClick("Low")}
                    >
                      Low
                    </NavItem>
                    <NavItem
                      active={supportTicket.request_priority === "Normal"}
                      onClick={() => this.onChangePriorityClick("Normal")}
                    >
                      Normal
                    </NavItem>
                    <NavItem
                      active={supportTicket.request_priority === "High"}
                      onClick={() => this.onChangePriorityClick("High")}
                    >
                      High
                    </NavItem>
                  </DropdownButton>
                </div>
              )}
              {supportTicket?.request_status && (
                <Badge
                  color={supportTicket.request_status.color}
                  className="ticket-status-badge"
                >
                  {supportTicket.request_status?.label}
                </Badge>
              )}
            </React.Fragment>
          }
          ticketView={isMobile}
          classNames="ticket-header-wrapper"
        />
        <SupportTicketDisplay
          supportTicket={supportTicket}
          toggleShow={this.toggleShow}
          open
        />
        {isExistingTicket ? (
          <>
            <HeaderWrapper
              breadcrumbs={[{ label: "Call History" }]}
              isMobile={isMobile}
              onClickAction={
                supportTicket?.request_status?.label !== "Resolved" && [
                  {
                    action: this.onClickAdd,
                    text: "Add Call",
                    className: "btn-success"
                  }
                ]
              }
            />
            <div className="content-wrapper">
              <CallList
                data={calls}
                customers={customers}
                projects={projects}
                users={users}
                codes={codes}
                isMobile={isMobile}
                onClickView={(id) =>
                  this.props.history.push(`/app/calls/${id}`)
                }
                onClickDelete={this.onClickDelete}
                sorted={[{ id: "created_on", asc: true }]}
              />
            </div>
          </>
        ) : (
          <>
            <HeaderWrapper
              breadcrumbs={[{ label: "Assign Ticket" }]}
              isMobile={isMobile}
            />
            <div className="content-wrapper">{assignForm}</div>
          </>
        )}
        <div>
          <HeaderWrapper
            breadcrumbs={[{ label: "Audit Log" }]}
            isMobile={isMobile}
            onClickAction={[
              {
                action: this.onClickAddLog,
                text: "Add Log",
                className: "btn-success"
              }
            ]}
          />
          <div className="content-wrapper">
            <AuditLogList
              minimal
              data={supportTicket?.audit_log}
              history={this.props.history}
              isMobile={isMobile}
            />
          </div>
        </div>
        <Modal
          id="supportTicketModal"
          title="Assign Ticket"
          body={assignForm}
          close={this.props.actions.hideModal}
        />
        <Modal
          id="supportTicketModalAddCall"
          title="Add Call to Ticket"
          body={addCallForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="resolveTicketModal"
          title="Resolve Ticket"
          body={confirmClose}
          confirm={this.handleResolve}
          close={this.onCloseModal}
        />
        <ConfirmModal
          id="holdTicketModal"
          title="Place Ticket On Hold"
          confirmLabel="Hold"
          disabled={!this.state.note || !this.state.actionRequiredBy}
          body={holdModalForm}
          confirm={this.handleHold}
          close={this.onCloseModal}
        />
        <ConfirmModal
          id="callConfirmModal"
          title={
            deleteRecurring
              ? `This call is part of a recurring series`
              : `Delete Call`
          }
          body={
            deleteRecurring
              ? `Do you want to delete this series or this single call?`
              : `Are you sure you want to delete this call?`
          }
          actions={deleteRecurring ? actions : ""}
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
        <ConfirmModal
          id="auditLogModal"
          title="New Audit Log"
          body={ticketModalForm}
          confirm={this.handleAddAuditLog}
          close={this.onCloseModal}
          disabled={!this.state.note}
        />
        <ConfirmModal
          id="priorityModal"
          title="Change Priority"
          body={changePriorityForm}
          close={this.onCloseModal}
          confirm={this.handleChangePriority}
          disabled={!this.state.note}
        />
        <ConfirmModal
          id="addAltNameModal"
          title="Add Alternative Customer Name"
          confirmLabel="Add"
          cancelLabel="Don't Add"
          body={
            <div>
              Would you like to add{" "}
              <b>{this.props.supportTicket.requestor_company_name}</b> as an
              alternative customer name for{" "}
              <b>{this.state.callToRedirect?.customer?.name}</b>
            </div>
          }
          confirm={this.handleAddAlternativeNameConfirm}
          close={this.handleAddAlternativeNameCancel}
        />
        <ConfirmModal
          id="projectKeywordsModal"
          title="Add Project Keywords"
          confirmLabel="Visit Page"
          cancelLabel="No"
          body={
            <div>
              Would you like to add keywords to{" "}
              <b>{this.state.callToRedirect?.project?.name}</b> to help select
              this project for future tickets
            </div>
          }
          confirm={this.handleAddProjectKeywordsConfirm}
          close={this.handleAddProjectKeywordsCancel}
        />
      </>
    );
  }
}

ViewSupportTicket.propTypes = {
  auth: PropTypes.object,
  actions: PropTypes.object,
  savingCall: PropTypes.bool,
  customers: PropTypes.array,
  users: PropTypes.array,
  contracts: PropTypes.array,
  projects: PropTypes.array,
  codes: PropTypes.array,
  params: PropTypes.object,
  supportTicket: PropTypes.object,
  callToDelete: PropTypes.string,
  history: PropTypes.object,
  isMobile: PropTypes.bool,
  match: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    savingCall: state.reducers.savingCall,
    projects: state.reducers.projects,
    customers: state.reducers.customers,
    codes: state.reducers.codes,
    users: state.reducers.users,
    contracts: state.reducers.contracts,
    supportTicket: state.reducers.supportTicket,
    supportTickets: state.reducers.supportTickets,
    router: state.router,
    callToDelete: state.reducers.callToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...callActions,
        ...modalActions,
        ...contractActions,
        ...contactActions,
        ...projectActions,
        ...userActions,
        ...serviceActions,
        ...customerActions,
        ...codeActions,
        ...supportTicketActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ViewSupportTicket);
